import * as Detail from "./Detail/index.js";
import * as Authorization from "./Authorization/index.js";
import * as Charting from "./Charting/index.js";
import * as Tenants from "./Tenants/index.js";
import * as Financial from "./Financial/index.js";
import * as Geography from "./Geography/index.js";
import * as LeaseDeals from "./LeaseDeals/index.js";
import * as Property from "./Property/index.js";
import * as Info from "./Info/index.js";
import * as IntegrationTesting from "./IntegrationTesting/index.js";
import * as Migrated from "./Migrated/index.js";
import * as Results from "./Results/index.js";
import * as SaleComps from "./SaleComps/index.js";
import * as Shapes from "./Shapes/index.js";
import * as SubscriptionAtom from "./SubscriptionAtom/index.js";
/** CoStar.Api.EnterpriseSub2.CurrencyType */
export var CurrencyType;
(function (CurrencyType) {
    CurrencyType[CurrencyType["None"] = 0] = "None";
    CurrencyType[CurrencyType["USDollar"] = 1] = "USDollar";
    CurrencyType[CurrencyType["CanadianDollar"] = 2] = "CanadianDollar";
    CurrencyType[CurrencyType["PoundSterling"] = 3] = "PoundSterling";
    CurrencyType[CurrencyType["Euro"] = 4] = "Euro";
})(CurrencyType || (CurrencyType = {}));
/** CoStar.Api.EnterpriseSub2.SaleCompEntityType */
export var SaleCompEntityType;
(function (SaleCompEntityType) {
    SaleCompEntityType[SaleCompEntityType["Unknown"] = 0] = "Unknown";
    SaleCompEntityType[SaleCompEntityType["ParentComp"] = 2] = "ParentComp";
    SaleCompEntityType[SaleCompEntityType["ChildComp"] = 3] = "ChildComp";
})(SaleCompEntityType || (SaleCompEntityType = {}));
/** CoStar.Api.EnterpriseSub2.DetailDataMode */
export var DetailDataMode;
(function (DetailDataMode) {
    DetailDataMode[DetailDataMode["Unknown"] = 0] = "Unknown";
    DetailDataMode[DetailDataMode["Property"] = 1] = "Property";
    DetailDataMode[DetailDataMode["ShoppingCenter"] = 2] = "ShoppingCenter";
})(DetailDataMode || (DetailDataMode = {}));
/** CoStar.Api.EnterpriseSub2.CommunicationMethod */
export var CommunicationMethod;
(function (CommunicationMethod) {
    CommunicationMethod[CommunicationMethod["InstantMessaging"] = 0] = "InstantMessaging";
    CommunicationMethod[CommunicationMethod["FaceTime"] = 1] = "FaceTime";
    CommunicationMethod[CommunicationMethod["Email"] = 2] = "Email";
})(CommunicationMethod || (CommunicationMethod = {}));
/** CoStar.Api.EnterpriseSub2.AttachmentType */
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType[AttachmentType["Unknown"] = 0] = "Unknown";
    AttachmentType[AttachmentType["Aerial"] = 1] = "Aerial";
    AttachmentType[AttachmentType["Financial"] = 2] = "Financial";
    AttachmentType[AttachmentType["PrimaryPhoto"] = 3] = "PrimaryPhoto";
    AttachmentType[AttachmentType["BuildingPhoto"] = 4] = "BuildingPhoto";
    AttachmentType[AttachmentType["VirtualTour"] = 5] = "VirtualTour";
    AttachmentType[AttachmentType["Lobby"] = 6] = "Lobby";
    AttachmentType[AttachmentType["Other"] = 7] = "Other";
    AttachmentType[AttachmentType["MarketingBrochure"] = 8] = "MarketingBrochure";
    AttachmentType[AttachmentType["PlatMap"] = 9] = "PlatMap";
    AttachmentType[AttachmentType["FloorPlan"] = 10] = "FloorPlan";
    AttachmentType[AttachmentType["SitePlan"] = 11] = "SitePlan";
    AttachmentType[AttachmentType["TypicalFloorPlan"] = 12] = "TypicalFloorPlan";
    AttachmentType[AttachmentType["Slate"] = 13] = "Slate";
    AttachmentType[AttachmentType["PrimaryContactPhoto"] = 14] = "PrimaryContactPhoto";
    AttachmentType[AttachmentType["Logo"] = 15] = "Logo";
    AttachmentType[AttachmentType["Map"] = 16] = "Map";
    AttachmentType[AttachmentType["SmallImage"] = 17] = "SmallImage";
    AttachmentType[AttachmentType["LargeImage"] = 18] = "LargeImage";
    AttachmentType[AttachmentType["TenantPhoto"] = 19] = "TenantPhoto";
    AttachmentType[AttachmentType["LeaseDocument"] = 20] = "LeaseDocument";
    AttachmentType[AttachmentType["PublicFiling"] = 21] = "PublicFiling";
    AttachmentType[AttachmentType["Deed"] = 22] = "Deed";
    AttachmentType[AttachmentType["TransferTaxDeclaration"] = 23] = "TransferTaxDeclaration";
    AttachmentType[AttachmentType["PropertyRecordCard"] = 24] = "PropertyRecordCard";
    AttachmentType[AttachmentType["RentAndLeaseAssignment"] = 25] = "RentAndLeaseAssignment";
    AttachmentType[AttachmentType["Loan"] = 26] = "Loan";
    AttachmentType[AttachmentType["Article"] = 27] = "Article";
    AttachmentType[AttachmentType["PressRelease"] = 28] = "PressRelease";
    AttachmentType[AttachmentType["SecuritiesExchangeCommissionFiling"] = 29] = "SecuritiesExchangeCommissionFiling";
    AttachmentType[AttachmentType["CompanyReport"] = 30] = "CompanyReport";
    AttachmentType[AttachmentType["MediaSource"] = 31] = "MediaSource";
    AttachmentType[AttachmentType["DirectoryPhoto"] = 32] = "DirectoryPhoto";
    AttachmentType[AttachmentType["InteriorPhoto"] = 33] = "InteriorPhoto";
    AttachmentType[AttachmentType["GoadMap"] = 34] = "GoadMap";
    AttachmentType[AttachmentType["VideoTour"] = 40] = "VideoTour";
})(AttachmentType || (AttachmentType = {}));
/** CoStar.Api.EnterpriseSub2.PhoneNumberType */
export var PhoneNumberType;
(function (PhoneNumberType) {
    /** @deprecated Specify one of the other types */
    PhoneNumberType[PhoneNumberType["Preferred"] = 0] = "Preferred";
    PhoneNumberType[PhoneNumberType["Office"] = 1] = "Office";
    PhoneNumberType[PhoneNumberType["Mobile"] = 2] = "Mobile";
    PhoneNumberType[PhoneNumberType["Fax"] = 3] = "Fax";
    PhoneNumberType[PhoneNumberType["Home"] = 4] = "Home";
    PhoneNumberType[PhoneNumberType["Pager"] = 5] = "Pager";
})(PhoneNumberType || (PhoneNumberType = {}));
/** CoStar.Api.EnterpriseSub2.BuildingCertifications */
export var BuildingCertifications;
(function (BuildingCertifications) {
    BuildingCertifications[BuildingCertifications["None"] = 0] = "None";
    BuildingCertifications[BuildingCertifications["EnergyStar"] = 1] = "EnergyStar";
    BuildingCertifications[BuildingCertifications["LEED"] = 2] = "LEED";
    BuildingCertifications[BuildingCertifications["BREEAM"] = 4] = "BREEAM";
})(BuildingCertifications || (BuildingCertifications = {}));
import { AdType } from "../../../CoStar/Api/FusionSearch/Result/index.js";
/** CoStar.Api.EnterpriseSub2.AdType */
export { AdType };
/** CoStar.Api.EnterpriseSub2.LandType */
export var LandType;
(function (LandType) {
    LandType[LandType["None"] = 0] = "None";
    LandType[LandType["Residential"] = 1] = "Residential";
    LandType[LandType["Commercial"] = 2] = "Commercial";
    LandType[LandType["Industrial"] = 3] = "Industrial";
    LandType[LandType["Agricultural"] = 4] = "Agricultural";
})(LandType || (LandType = {}));
/** CoStar.Api.EnterpriseSub2.IndustryType */
export var IndustryType;
(function (IndustryType) {
    IndustryType[IndustryType["None"] = 0] = "None";
    IndustryType[IndustryType["TransportationAndWarehousing"] = 2] = "TransportationAndWarehousing";
    IndustryType[IndustryType["RealEstate"] = 4] = "RealEstate";
    IndustryType[IndustryType["Manufacturing"] = 5] = "Manufacturing";
    IndustryType[IndustryType["Retailer"] = 6] = "Retailer";
    IndustryType[IndustryType["FinanceAndInsurance"] = 7] = "FinanceAndInsurance";
    IndustryType[IndustryType["PublicAdministration"] = 9] = "PublicAdministration";
    IndustryType[IndustryType["Construction"] = 10] = "Construction";
    IndustryType[IndustryType["Information"] = 11] = "Information";
    IndustryType[IndustryType["ProfessionalScientificAndTechnicalServices"] = 12] = "ProfessionalScientificAndTechnicalServices";
    IndustryType[IndustryType["Services"] = 13] = "Services";
    IndustryType[IndustryType["HealthcareAndSocialAssistance"] = 15] = "HealthcareAndSocialAssistance";
    IndustryType[IndustryType["AccommodationAndFoodservices"] = 17] = "AccommodationAndFoodservices";
    IndustryType[IndustryType["AdministrativeAndSupportServices"] = 18] = "AdministrativeAndSupportServices";
    IndustryType[IndustryType["AgricultureForestryFishingAndHunting"] = 19] = "AgricultureForestryFishingAndHunting";
    IndustryType[IndustryType["ArtsEntertainmentAndRecreation"] = 20] = "ArtsEntertainmentAndRecreation";
    IndustryType[IndustryType["EducationalServices"] = 21] = "EducationalServices";
    IndustryType[IndustryType["ManagementOfCompaniesAndEnterprises"] = 22] = "ManagementOfCompaniesAndEnterprises";
    IndustryType[IndustryType["MiningQuarryingAndOilAndGasExtraction"] = 23] = "MiningQuarryingAndOilAndGasExtraction";
    IndustryType[IndustryType["RentalAndLeasingServices"] = 24] = "RentalAndLeasingServices";
    IndustryType[IndustryType["Utilities"] = 25] = "Utilities";
    IndustryType[IndustryType["WasteManagementAndRemediationServices"] = 26] = "WasteManagementAndRemediationServices";
    IndustryType[IndustryType["Wholesaler"] = 27] = "Wholesaler";
})(IndustryType || (IndustryType = {}));
/** CoStar.Api.EnterpriseSub2.PropertyType */
export var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["None"] = 0] = "None";
    PropertyType[PropertyType["Hospitality"] = 1] = "Hospitality";
    PropertyType[PropertyType["Industrial"] = 2] = "Industrial";
    PropertyType[PropertyType["Land"] = 3] = "Land";
    PropertyType[PropertyType["Office"] = 5] = "Office";
    PropertyType[PropertyType["GeneralRetail"] = 6] = "GeneralRetail";
    PropertyType[PropertyType["Flex"] = 7] = "Flex";
    PropertyType[PropertyType["SportsAndEntertainment"] = 8] = "SportsAndEntertainment";
    PropertyType[PropertyType["MixedUse"] = 9] = "MixedUse";
    PropertyType[PropertyType["Specialty"] = 10] = "Specialty";
    PropertyType[PropertyType["Multifamily"] = 11] = "Multifamily";
    PropertyType[PropertyType["Healthcare"] = 13] = "Healthcare";
    PropertyType[PropertyType["Unknown"] = 14] = "Unknown";
    PropertyType[PropertyType["Residential"] = 15] = "Residential";
    PropertyType[PropertyType["Student"] = 31] = "Student";
})(PropertyType || (PropertyType = {}));
/** CoStar.Api.EnterpriseSub2.SpaceUseId */
export var SpaceUseId;
(function (SpaceUseId) {
    SpaceUseId[SpaceUseId["None"] = 0] = "None";
    SpaceUseId[SpaceUseId["Office"] = 1] = "Office";
    SpaceUseId[SpaceUseId["OfficeMedical"] = 2] = "OfficeMedical";
    SpaceUseId[SpaceUseId["OfficeRetail"] = 3] = "OfficeRetail";
    SpaceUseId[SpaceUseId["Medical"] = 4] = "Medical";
    SpaceUseId[SpaceUseId["Retail"] = 5] = "Retail";
    SpaceUseId[SpaceUseId["Flex"] = 6] = "Flex";
    SpaceUseId[SpaceUseId["Industrial"] = 7] = "Industrial";
})(SpaceUseId || (SpaceUseId = {}));
/** CoStar.Api.EnterpriseSub2.SaleComparablePropertySizeType */
export var SaleComparablePropertySizeType;
(function (SaleComparablePropertySizeType) {
    SaleComparablePropertySizeType[SaleComparablePropertySizeType["None"] = 0] = "None";
    SaleComparablePropertySizeType[SaleComparablePropertySizeType["SquareFoot"] = 1] = "SquareFoot";
    SaleComparablePropertySizeType[SaleComparablePropertySizeType["Acre"] = 2] = "Acre";
    SaleComparablePropertySizeType[SaleComparablePropertySizeType["Unit"] = 3] = "Unit";
    SaleComparablePropertySizeType[SaleComparablePropertySizeType["Room"] = 4] = "Room";
})(SaleComparablePropertySizeType || (SaleComparablePropertySizeType = {}));
/** CoStar.Api.EnterpriseSub2.AreaType */
export var AreaType;
(function (AreaType) {
    AreaType[AreaType["None"] = 0] = "None";
    AreaType[AreaType["International"] = 1] = "International";
    AreaType[AreaType["National"] = 2] = "National";
    AreaType[AreaType["Regional"] = 3] = "Regional";
    AreaType[AreaType["Local"] = 4] = "Local";
})(AreaType || (AreaType = {}));
/** CoStar.Api.EnterpriseSub2.OrgType */
export var OrgType;
(function (OrgType) {
    OrgType[OrgType["None"] = 0] = "None";
    OrgType[OrgType["CorpOrLLC"] = 1] = "CorpOrLLC";
    OrgType[OrgType["PartnershipOrLLP"] = 2] = "PartnershipOrLLP";
    OrgType[OrgType["Nonprofit"] = 3] = "Nonprofit";
    OrgType[OrgType["SoleProp"] = 4] = "SoleProp";
    OrgType[OrgType["Government"] = 5] = "Government";
    OrgType[OrgType["Association"] = 6] = "Association";
})(OrgType || (OrgType = {}));
/** CoStar.Api.EnterpriseSub2.EmployeeGrowthType */
export var EmployeeGrowthType;
(function (EmployeeGrowthType) {
    EmployeeGrowthType[EmployeeGrowthType["None"] = 0] = "None";
    EmployeeGrowthType[EmployeeGrowthType["Stable"] = 1] = "Stable";
    EmployeeGrowthType[EmployeeGrowthType["Growing"] = 2] = "Growing";
    EmployeeGrowthType[EmployeeGrowthType["GrowingRapidly"] = 3] = "GrowingRapidly";
    EmployeeGrowthType[EmployeeGrowthType["Downsizing"] = 4] = "Downsizing";
    EmployeeGrowthType[EmployeeGrowthType["Bankrupt"] = 5] = "Bankrupt";
})(EmployeeGrowthType || (EmployeeGrowthType = {}));
/** CoStar.Api.EnterpriseSub2.OfficeType */
export var OfficeType;
(function (OfficeType) {
    OfficeType[OfficeType["None"] = 0] = "None";
    OfficeType[OfficeType["MainHQ"] = 1] = "MainHQ";
    OfficeType[OfficeType["DivisionalHQ"] = 2] = "DivisionalHQ";
    OfficeType[OfficeType["CorporateOffice"] = 3] = "CorporateOffice";
    OfficeType[OfficeType["Franchise"] = 4] = "Franchise";
    OfficeType[OfficeType["SingleLocation"] = 5] = "SingleLocation";
    OfficeType[OfficeType["RetailStoreBranch"] = 6] = "RetailStoreBranch";
    OfficeType[OfficeType["Warehouse"] = 7] = "Warehouse";
    OfficeType[OfficeType["OnSitePropertyManagementNoOccupancy"] = 8] = "OnSitePropertyManagementNoOccupancy";
})(OfficeType || (OfficeType = {}));
/** CoStar.Api.EnterpriseSub2.RentType */
export var RentType;
(function (RentType) {
    RentType[RentType["None"] = 0] = "None";
    RentType[RentType["Asking"] = 1] = "Asking";
    RentType[RentType["Contract"] = 2] = "Contract";
    RentType[RentType["Effective"] = 3] = "Effective";
    RentType[RentType["NPVPerSFPeryr"] = 4] = "NPVPerSFPeryr";
    RentType[RentType["AnnuitizedNetEffectiveRent"] = 5] = "AnnuitizedNetEffectiveRent";
})(RentType || (RentType = {}));
/** CoStar.Api.EnterpriseSub2.ServiceType */
export var ServiceType;
(function (ServiceType) {
    ServiceType[ServiceType["None"] = 0] = "None";
    ServiceType[ServiceType["PlusCleaning"] = 1] = "PlusCleaning";
    ServiceType[ServiceType["PlusElectricAndClean"] = 2] = "PlusElectricAndClean";
    ServiceType[ServiceType["PlusElectric"] = 4] = "PlusElectric";
    ServiceType[ServiceType["UtilitiesAndChar"] = 5] = "UtilitiesAndChar";
    ServiceType[ServiceType["PlusAllUtilities"] = 6] = "PlusAllUtilities";
    ServiceType[ServiceType["FullServiceGross"] = 7] = "FullServiceGross";
    ServiceType[ServiceType["IndustrialGross"] = 8] = "IndustrialGross";
    ServiceType[ServiceType["ModifiedGross"] = 9] = "ModifiedGross";
    ServiceType[ServiceType["Net"] = 10] = "Net";
    ServiceType[ServiceType["Negotiable"] = 11] = "Negotiable";
    ServiceType[ServiceType["DoubleNet"] = 12] = "DoubleNet";
    ServiceType[ServiceType["TripleNet"] = 13] = "TripleNet";
    ServiceType[ServiceType["TBD"] = 14] = "TBD";
    ServiceType[ServiceType["TenantElectric"] = 15] = "TenantElectric";
    ServiceType[ServiceType["FullyRepairingAndInsuring"] = 16] = "FullyRepairingAndInsuring";
    ServiceType[ServiceType["InternalRepairingOnly"] = 17] = "InternalRepairingOnly";
    ServiceType[ServiceType["InternalRepairingAndInsuring"] = 18] = "InternalRepairingAndInsuring";
    ServiceType[ServiceType["FullServiceGrossNoPass"] = 19] = "FullServiceGrossNoPass";
})(ServiceType || (ServiceType = {}));
/** CoStar.Api.EnterpriseSub2.LeaseType */
export var LeaseType;
(function (LeaseType) {
    LeaseType[LeaseType["None"] = 0] = "None";
    LeaseType[LeaseType["Direct"] = 1] = "Direct";
    LeaseType[LeaseType["Sublease"] = 2] = "Sublease";
    LeaseType[LeaseType["MonthToMonth"] = 3] = "MonthToMonth";
    LeaseType[LeaseType["Owned"] = 4] = "Owned";
    LeaseType[LeaseType["Assignment"] = 5] = "Assignment";
    LeaseType[LeaseType["CoWorking"] = 6] = "CoWorking";
})(LeaseType || (LeaseType = {}));
/** CoStar.Api.EnterpriseSub2.TenantType */
export var TenantType;
(function (TenantType) {
    TenantType[TenantType["None"] = 0] = "None";
    TenantType[TenantType["Anchor"] = 1] = "Anchor";
    TenantType[TenantType["Outparcel"] = 2] = "Outparcel";
    TenantType[TenantType["Regular"] = 3] = "Regular";
    TenantType[TenantType["InOfficeBuilding"] = 4] = "InOfficeBuilding";
    TenantType[TenantType["InStoreTenant"] = 5] = "InStoreTenant";
    TenantType[TenantType["EndCap"] = 6] = "EndCap";
    TenantType[TenantType["Inline"] = 7] = "Inline";
    TenantType[TenantType["Vacant"] = 8] = "Vacant";
})(TenantType || (TenantType = {}));
/** CoStar.Api.EnterpriseSub2.SearchType */
export var SearchType;
(function (SearchType) {
    SearchType[SearchType["Property"] = 0] = "Property";
    SearchType[SearchType["ForLease"] = 1] = "ForLease";
    SearchType[SearchType["ForSale"] = 2] = "ForSale";
    SearchType[SearchType["LeaseComps"] = 3] = "LeaseComps";
    SearchType[SearchType["SaleComps"] = 4] = "SaleComps";
    SearchType[SearchType["Tenants"] = 5] = "Tenants";
})(SearchType || (SearchType = {}));
/** CoStar.Api.EnterpriseSub2.BuildingClass */
export var BuildingClass;
(function (BuildingClass) {
    BuildingClass[BuildingClass["None"] = 0] = "None";
    BuildingClass[BuildingClass["ClassA"] = 1] = "ClassA";
    BuildingClass[BuildingClass["ClassB"] = 2] = "ClassB";
    BuildingClass[BuildingClass["ClassC"] = 3] = "ClassC";
    BuildingClass[BuildingClass["ClassF"] = 4] = "ClassF";
})(BuildingClass || (BuildingClass = {}));
/** CoStar.Api.EnterpriseSub2.GeographyType */
export var GeographyType;
(function (GeographyType) {
    GeographyType[GeographyType["Unknown"] = 0] = "Unknown";
    GeographyType[GeographyType["PostalCode"] = 2] = "PostalCode";
    GeographyType[GeographyType["City"] = 3] = "City";
    GeographyType[GeographyType["Submarket"] = 5] = "Submarket";
    GeographyType[GeographyType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyType[GeographyType["County"] = 10] = "County";
    GeographyType[GeographyType["Subdivision"] = 11] = "Subdivision";
    GeographyType[GeographyType["Country"] = 15] = "Country";
    GeographyType[GeographyType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyType[GeographyType["Region"] = 17] = "Region";
})(GeographyType || (GeographyType = {}));
/** CoStar.Api.EnterpriseSub2.ImageSize */
export var ImageSize;
(function (ImageSize) {
    ImageSize[ImageSize["Unknown"] = 0] = "Unknown";
    ImageSize[ImageSize["Master"] = 1] = "Master";
    ImageSize[ImageSize["Small"] = 4] = "Small";
    ImageSize[ImageSize["Thumbnail"] = 5] = "Thumbnail";
    ImageSize[ImageSize["Edit"] = 6] = "Edit";
    ImageSize[ImageSize["Enlarge"] = 7] = "Enlarge";
    ImageSize[ImageSize["Large"] = 10] = "Large";
    ImageSize[ImageSize["ExtraLarge"] = 11] = "ExtraLarge";
    ImageSize[ImageSize["HighDefinition"] = 12] = "HighDefinition";
    ImageSize[ImageSize["Widescreen"] = 13] = "Widescreen";
    ImageSize[ImageSize["GoLarge"] = 14] = "GoLarge";
    ImageSize[ImageSize["GoDetail"] = 15] = "GoDetail";
    ImageSize[ImageSize["GoLargeHighDefinition"] = 16] = "GoLargeHighDefinition";
    ImageSize[ImageSize["GoDetailHighDefinition"] = 17] = "GoDetailHighDefinition";
    ImageSize[ImageSize["GoThumbnailHighDefinition"] = 18] = "GoThumbnailHighDefinition";
})(ImageSize || (ImageSize = {}));
/** CoStar.Api.EnterpriseSub2.LeaseTermOptionType */
export var LeaseTermOptionType;
(function (LeaseTermOptionType) {
    LeaseTermOptionType[LeaseTermOptionType["None"] = 0] = "None";
    LeaseTermOptionType[LeaseTermOptionType["Renewal"] = 1] = "Renewal";
    LeaseTermOptionType[LeaseTermOptionType["Expansion"] = 2] = "Expansion";
    LeaseTermOptionType[LeaseTermOptionType["RightOfFirstRefusal"] = 3] = "RightOfFirstRefusal";
    LeaseTermOptionType[LeaseTermOptionType["Termination"] = 4] = "Termination";
    LeaseTermOptionType[LeaseTermOptionType["Purchase"] = 5] = "Purchase";
    LeaseTermOptionType[LeaseTermOptionType["RightOfFirstOffer"] = 6] = "RightOfFirstOffer";
})(LeaseTermOptionType || (LeaseTermOptionType = {}));
/** CoStar.Api.EnterpriseSub2.RateEscalationType */
export var RateEscalationType;
(function (RateEscalationType) {
    RateEscalationType[RateEscalationType["None"] = 0] = "None";
    RateEscalationType[RateEscalationType["MonetaryIncrease"] = 1] = "MonetaryIncrease";
    RateEscalationType[RateEscalationType["Cpi"] = 2] = "Cpi";
    RateEscalationType[RateEscalationType["FixedPercentIncrease"] = 3] = "FixedPercentIncrease";
    RateEscalationType[RateEscalationType["Negotiable"] = 4] = "Negotiable";
    RateEscalationType[RateEscalationType["ToMarket"] = 5] = "ToMarket";
    RateEscalationType[RateEscalationType["EachCalendarYear"] = 6] = "EachCalendarYear";
    RateEscalationType[RateEscalationType["MidLeaseTerm"] = 7] = "MidLeaseTerm";
    RateEscalationType[RateEscalationType["SpecificDate"] = 8] = "SpecificDate";
    RateEscalationType[RateEscalationType["IntervalAfterLeaseStart"] = 9] = "IntervalAfterLeaseStart";
    RateEscalationType[RateEscalationType["IntervalStartingOnSpecDate"] = 10] = "IntervalStartingOnSpecDate";
})(RateEscalationType || (RateEscalationType = {}));
/** CoStar.Api.EnterpriseSub2.RateEscalationAmountType */
export var RateEscalationAmountType;
(function (RateEscalationAmountType) {
    RateEscalationAmountType[RateEscalationAmountType["None"] = 0] = "None";
    RateEscalationAmountType[RateEscalationAmountType["StepRatePerAreaOrAmount"] = 1] = "StepRatePerAreaOrAmount";
    RateEscalationAmountType[RateEscalationAmountType["StepPercent"] = 2] = "StepPercent";
    RateEscalationAmountType[RateEscalationAmountType["Cpi"] = 3] = "Cpi";
    RateEscalationAmountType[RateEscalationAmountType["ToMarket"] = 4] = "ToMarket";
})(RateEscalationAmountType || (RateEscalationAmountType = {}));
/** CoStar.Api.EnterpriseSub2.LeaseDealSourceGroupType */
export var LeaseDealSourceGroupType;
(function (LeaseDealSourceGroupType) {
    LeaseDealSourceGroupType[LeaseDealSourceGroupType["None"] = 0] = "None";
    LeaseDealSourceGroupType[LeaseDealSourceGroupType["Direct"] = 1] = "Direct";
    LeaseDealSourceGroupType[LeaseDealSourceGroupType["Media"] = 2] = "Media";
    LeaseDealSourceGroupType[LeaseDealSourceGroupType["PublicRecord"] = 3] = "PublicRecord";
    LeaseDealSourceGroupType[LeaseDealSourceGroupType["ThirdParty"] = 4] = "ThirdParty";
})(LeaseDealSourceGroupType || (LeaseDealSourceGroupType = {}));
/** CoStar.Api.EnterpriseSub2.SpacePosition */
export var SpacePosition;
(function (SpacePosition) {
    SpacePosition[SpacePosition["None"] = 0] = "None";
    SpacePosition[SpacePosition["FoodCourt"] = 1] = "FoodCourt";
    SpacePosition[SpacePosition["Inline"] = 2] = "Inline";
    SpacePosition[SpacePosition["EndCap"] = 3] = "EndCap";
    SpacePosition[SpacePosition["Outparcel"] = 4] = "Outparcel";
})(SpacePosition || (SpacePosition = {}));
/** CoStar.Api.EnterpriseSub2.FreeRentMethodType */
export var FreeRentMethodType;
(function (FreeRentMethodType) {
    FreeRentMethodType[FreeRentMethodType["MonthsAtStart"] = 0] = "MonthsAtStart";
    FreeRentMethodType[FreeRentMethodType["MonthsSpreadOverTerm"] = 1] = "MonthsSpreadOverTerm";
})(FreeRentMethodType || (FreeRentMethodType = {}));
/** CoStar.Api.EnterpriseSub2.SpaceType */
export var SpaceType;
(function (SpaceType) {
    SpaceType[SpaceType["None"] = 0] = "None";
    SpaceType[SpaceType["Relet"] = 1] = "Relet";
    SpaceType[SpaceType["New"] = 2] = "New";
    SpaceType[SpaceType["Sublet"] = 3] = "Sublet";
    SpaceType[SpaceType["Assignment"] = 4] = "Assignment";
})(SpaceType || (SpaceType = {}));
/** CoStar.Api.EnterpriseSub2.PointOfInterestGroup */
export var PointOfInterestGroup;
(function (PointOfInterestGroup) {
    PointOfInterestGroup[PointOfInterestGroup["None"] = 0] = "None";
    PointOfInterestGroup[PointOfInterestGroup["Bank"] = 1] = "Bank";
    PointOfInterestGroup[PointOfInterestGroup["Bar"] = 2] = "Bar";
    PointOfInterestGroup[PointOfInterestGroup["Coffee"] = 3] = "Coffee";
    PointOfInterestGroup[PointOfInterestGroup["Fitness"] = 4] = "Fitness";
    PointOfInterestGroup[PointOfInterestGroup["Grocery"] = 5] = "Grocery";
    PointOfInterestGroup[PointOfInterestGroup["Restaurant"] = 6] = "Restaurant";
    PointOfInterestGroup[PointOfInterestGroup["Shop"] = 7] = "Shop";
})(PointOfInterestGroup || (PointOfInterestGroup = {}));
/** CoStar.Api.EnterpriseSub2.PropertyLevel */
export var PropertyLevel;
(function (PropertyLevel) {
    PropertyLevel[PropertyLevel["FullyResearched"] = 0] = "FullyResearched";
    PropertyLevel[PropertyLevel["PinsOnly"] = 1] = "PinsOnly";
})(PropertyLevel || (PropertyLevel = {}));
/** CoStar.Api.EnterpriseSub2.MiscSpaceRateType */
export var MiscSpaceRateType;
(function (MiscSpaceRateType) {
    MiscSpaceRateType[MiscSpaceRateType["None"] = 0] = "None";
    MiscSpaceRateType[MiscSpaceRateType["Office"] = 1] = "Office";
    MiscSpaceRateType[MiscSpaceRateType["Industrial"] = 2] = "Industrial";
    MiscSpaceRateType[MiscSpaceRateType["Laboratory"] = 3] = "Laboratory";
    MiscSpaceRateType[MiscSpaceRateType["Showroom"] = 4] = "Showroom";
    MiscSpaceRateType[MiscSpaceRateType["Shell"] = 5] = "Shell";
    MiscSpaceRateType[MiscSpaceRateType["OtherSalesArea"] = 6] = "OtherSalesArea";
    MiscSpaceRateType[MiscSpaceRateType["AncillarySpace"] = 7] = "AncillarySpace";
    MiscSpaceRateType[MiscSpaceRateType["MainSalesArea"] = 8] = "MainSalesArea";
})(MiscSpaceRateType || (MiscSpaceRateType = {}));
/** CoStar.Api.EnterpriseSub2.BuildOutCondition */
export var BuildOutCondition;
(function (BuildOutCondition) {
    BuildOutCondition[BuildOutCondition["None"] = 0] = "None";
    BuildOutCondition[BuildOutCondition["AboveStandard"] = 1] = "AboveStandard";
    BuildOutCondition[BuildOutCondition["DentalOffice"] = 2] = "DentalOffice";
    BuildOutCondition[BuildOutCondition["Restaurant"] = 3] = "Restaurant";
    BuildOutCondition[BuildOutCondition["LawFirm"] = 4] = "LawFirm";
    BuildOutCondition[BuildOutCondition["MedicalSpace"] = 5] = "MedicalSpace";
    BuildOutCondition[BuildOutCondition["Other"] = 6] = "Other";
    BuildOutCondition[BuildOutCondition["MoveIn"] = 7] = "MoveIn";
    BuildOutCondition[BuildOutCondition["Shell"] = 8] = "Shell";
})(BuildOutCondition || (BuildOutCondition = {}));
/** CoStar.Api.EnterpriseSub2.BuildOutStatus */
export var BuildOutStatus;
(function (BuildOutStatus) {
    BuildOutStatus[BuildOutStatus["None"] = 0] = "None";
    BuildOutStatus[BuildOutStatus["RawSpace"] = 1] = "RawSpace";
    BuildOutStatus[BuildOutStatus["ShellSpace"] = 2] = "ShellSpace";
    BuildOutStatus[BuildOutStatus["PartialBuildOut"] = 3] = "PartialBuildOut";
    BuildOutStatus[BuildOutStatus["FullBuildOut"] = 4] = "FullBuildOut";
})(BuildOutStatus || (BuildOutStatus = {}));
/** CoStar.Api.EnterpriseSub2.AvailabilityType */
export var AvailabilityType;
(function (AvailabilityType) {
    AvailabilityType[AvailabilityType["None"] = 0] = "None";
    AvailabilityType[AvailabilityType["ThirtyDays"] = 1] = "ThirtyDays";
    AvailabilityType[AvailabilityType["SixtyDays"] = 2] = "SixtyDays";
    AvailabilityType[AvailabilityType["NinetyDays"] = 3] = "NinetyDays";
    AvailabilityType[AvailabilityType["OneTwentyDays"] = 4] = "OneTwentyDays";
    AvailabilityType[AvailabilityType["ToBeDetermined"] = 5] = "ToBeDetermined";
    AvailabilityType[AvailabilityType["Arranged"] = 6] = "Arranged";
    AvailabilityType[AvailabilityType["Negotiable"] = 7] = "Negotiable";
})(AvailabilityType || (AvailabilityType = {}));
import { RateBasis } from "../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.EnterpriseSub2.RateBasis */
export { RateBasis };
/** CoStar.Api.EnterpriseSub2.SpaceLayout */
export var SpaceLayout;
(function (SpaceLayout) {
    SpaceLayout[SpaceLayout["None"] = 0] = "None";
    SpaceLayout[SpaceLayout["OpenPlan"] = 1] = "OpenPlan";
    SpaceLayout[SpaceLayout["MostlyOpenPlan"] = 2] = "MostlyOpenPlan";
    SpaceLayout[SpaceLayout["PrivateOffices"] = 3] = "PrivateOffices";
})(SpaceLayout || (SpaceLayout = {}));
/** CoStar.Api.EnterpriseSub2.SaleEntityTypes */
export var SaleEntityTypes;
(function (SaleEntityTypes) {
    SaleEntityTypes[SaleEntityTypes["None"] = 0] = "None";
    SaleEntityTypes[SaleEntityTypes["Property"] = 1] = "Property";
    SaleEntityTypes[SaleEntityTypes["Condo"] = 2] = "Condo";
})(SaleEntityTypes || (SaleEntityTypes = {}));
/** CoStar.Api.EnterpriseSub2.CompanyType */
export var CompanyType;
(function (CompanyType) {
    CompanyType[CompanyType["None"] = 0] = "None";
    CompanyType[CompanyType["Private"] = 1] = "Private";
    CompanyType[CompanyType["Public"] = 2] = "Public";
})(CompanyType || (CompanyType = {}));
export { Detail, Authorization, Charting, Tenants, Financial, Geography, LeaseDeals, Property, Info, IntegrationTesting, Migrated, Results, SaleComps, Shapes, SubscriptionAtom };
